define('plugin/invoice/view/InvoiceRecurringProfileView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Invoice recurring profile details view
     *
     * @class InvoiceRecurringProfileView
     */
    return LayoutView.extend({

        template: '#invoice_recurring_profile_view',
        modelEvents: {
            'sync': 'safeRender',
            'error': 'safeRender'
        },
        ui: {
            'cancelBtn': '#sb_cancel_profile'
        },
        triggers: {
            'click @ui.cancelBtn': 'profile:cancel'
        },

        safeRender: function (event) {
            if (!this.isDestroyed) {
                this.render();
            }
        }

    });

});
